import React, { useState, useEffect } from 'react';
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CButton,
  CBadge
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilSettings, cilHome, cilMoon, cilSun } from '@coreui/icons';
import { smartThingsService } from '../../../services/smartThingsService';
import { toast } from 'react-toastify';

// Sample automation data
const sampleAutomations = {
  scenes: [
    {
      sceneId: 'morning-routine',
      sceneName: 'Morning Routine',
      icon: cilSun,
      description: 'Opens blinds, turns on lights at 30%, starts coffee maker'
    },
    {
      sceneId: 'evening-mode',
      sceneName: 'Evening Mode',
      icon: cilMoon,
      description: 'Dims lights, adjusts temperature, locks doors'
    },
    {
      sceneId: 'movie-time',
      sceneName: 'Movie Time',
      icon: cilHome,
      description: 'Dims lights, turns on TV, sets sound system'
    },
    {
      sceneId: 'away-mode',
      sceneName: 'Away Mode',
      icon: cilHome,
      description: 'Turns off all lights, sets security system, adjusts thermostat'
    }
  ]
};

const HomeAssistantAutomations = () => {
  const [scenes, setScenes] = useState(sampleAutomations.scenes);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    checkConnection();
  }, []);

  const checkConnection = async () => {
    try {
      const token = await smartThingsService.getValidToken();
      setIsConnected(!!token);
      if (token) {
        fetchScenes();
      }
    } catch (error) {
      console.error('Error checking connection:', error);
    }
  };

  const fetchScenes = async () => {
    try {
      const token = await smartThingsService.getValidToken();
      if (token) {
        const response = await smartThingsService.getScenes(token);
        if (response.items && response.items.length > 0) {
          setScenes([...sampleAutomations.scenes, ...response.items]);
        }
      }
    } catch (error) {
      console.error('Error fetching scenes:', error);
      toast.error('Failed to fetch scenes');
    }
  };

  const executeScene = async (sceneId) => {
    try {
      const token = await smartThingsService.getValidToken();
      if (token) {
        await smartThingsService.executeScene(token, sceneId);
        toast.success('Scene executed successfully');
      } else {
        // Simulate execution for sample scenes
        toast.success('Demo: Scene would be executed here');
      }
    } catch (error) {
      console.error('Error executing scene:', error);
      toast.error('Failed to execute scene');
    }
  };

  return (
    <CRow>
      <CCol md={12}>
        <CCard className="mb-4">
          <CCardHeader>
            <CIcon icon={cilSettings} className="me-2" />
            Scenes & Automations
          </CCardHeader>
          <CCardBody>
            {scenes.map(scene => (
              <div key={scene.sceneId} className="d-flex justify-content-between align-items-center mb-4 p-3 border rounded">
                <div className="d-flex align-items-center">
                  <CIcon icon={scene.icon || cilSettings} className="me-3" size="xl" />
                  <div>
                    <h5 className="mb-1">{scene.sceneName}</h5>
                    {scene.description && (
                      <small className="mb-2">{scene.description}</small>
                    )}
                  </div>
                </div>
                <CButton
                  color="primary"
                  size="sm"
                  onClick={() => executeScene(scene.sceneId)}
                >
                  Execute
                </CButton>
              </div>
            ))}
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  );
};

export default HomeAssistantAutomations;


